import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import * as auth from '../_redux/authRedux';
import { getUserOrganizations } from '../_redux/authCrud';

const SSO_ERROR_MESSAGES = {
  access_denied:   'Access was denied. Please contact your IT administrator.',
  not_configured:  'SSO is not configured for your organization.',
  domain_mismatch: 'Your email domain is not authorized for SSO login.',
  session_expired: 'Your SSO session expired. Please try again.',
};

function SSOCallback(props) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    const errorParam  = searchParams.get('error') || searchParams.get('sso_error');
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');

    if (errorParam) {
      setError(SSO_ERROR_MESSAGES[errorParam] || errorParam || 'SSO sign-in failed. Please try again.');
      return;
    }

    if (!accessToken || !refreshToken) {
      setError('Invalid SSO response. Missing authentication tokens.');
      return;
    }

    async function completeLogin() {
      try {
        props.login(accessToken, refreshToken);
        const res  = await getUserOrganizations();
        const orgs = res.data.organizations || [];
        dispatch(auth.actions.fulfillOrgs(orgs));
        navigate(orgs.length === 0 ? '/auth/organization-setup' : '/', { replace: true });
      } catch {
        setError('Failed to load your account. Please try signing in again.');
      }
    }

    completeLogin();
  }, []);

  if (error) {
    return (
      <div className="clean-login-card">
        <div className="login-header">
          <h1 className="login-title">Sign-in failed</h1>
        </div>
        <div className="login-alert" style={{ marginBottom: 20 }}>{error}</div>
        <button className="submit-btn" onClick={() => navigate('/auth/login')}>
          Back to Sign In
        </button>
      </div>
    );
  }

  return (
    <div className="clean-login-card">
      <div style={{ textAlign: 'center', padding: '24px 0' }}>
        <span className="spinner" style={{ display: 'inline-block', marginBottom: 16 }} />
        <p style={{ fontSize: 14, color: '#64748B', margin: 0 }}>Completing SSO sign in…</p>
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(SSOCallback);
